import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FgiBackEndService } from '../fgi-back-end.service';
import { useCache } from "@bndes/bndes-ux4/bndes-angular-utils";
import moment from "moment";
import { LimiteFundoCadastro } from 'src/app/model/limite-agente-financeiro.model';
import { LimiteService } from 'src/app/shared/services/limite.service';

@Injectable({ providedIn: 'root'})
export class DataReferenciaLimiteFundoResolver implements Resolve<Observable<Date>> {

    constructor(
         private limiteService: LimiteService
    ) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<Date>  {

        return this.limiteService.getDataLimiteFundo(new Date());
    }
}
